import { render, staticRenderFns } from "./VPNPoolShow.vue?vue&type=template&id=163e7e00&"
import script from "./VPNPoolShow.vue?vue&type=script&lang=js&"
export * from "./VPNPoolShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports